import { createFileRoute } from "@tanstack/react-router";
import { WaitingBackend } from "@/components/waiting-backend";

export const Route = createFileRoute("/maintenance")({
  component: () => (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Manutenções</h1>
        <p className="text-sm text-muted-foreground">Planos preventivos, revisões e ordens de serviço.</p>
      </div>
      <WaitingBackend />
    </div>
  ),
  head: () => ({ meta: [{ title: "Manutenções — Wp Rastreamento" }] }),
});
